import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import '../About.css';

const WebDevelopment = () => {
  const services = [
    'Enterprise Web Applications',
    'Progressive Web Apps (PWA)',
    'E-commerce Platforms',
    'Content Management Systems',
    'API Development & Integration',
    'Performance Optimization'
  ];

  return (
    <div className="about-page">
      <section className="about-hero">
        <div className="container">
          <h1>Web Application Development</h1>
          <p>
            Scalable, secure web applications built with React, Node.js, and 
            modern frameworks for optimal performance.
          </p>
        </div>
      </section>

      <section className="about-story">
        <div className="container">
          <div className="story-content">
            <h2>Overview</h2>
            <p>
              Modern web applications require robust architecture, responsive design, and seamless 
              user experiences. We build enterprise-grade web solutions using proven frameworks 
              and best practices for security, performance, and maintainability.
            </p>
            <p>
              Our development process includes comprehensive testing, security audits, and performance 
              optimization to ensure your application meets enterprise standards and scales with your business.
            </p>
          </div>
        </div>
      </section>

      <section className="about-expertise">
        <div className="container">
          <div className="section-header">
            <h2>Web Development Services</h2>
            <p>Full-stack web application development capabilities</p>
          </div>
          <div className="expertise-grid">
            {services.map((service, index) => (
              <div key={index} className="expertise-item">
                {service}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="about-cta">
        <div className="container">
          <div className="cta-content">
            <h2>Build Your Web Application</h2>
            <p>Discuss your web development requirements and project timeline.</p>
            <Link to="/contact">
              <Button 
                variant="contained"
                size="large"
                endIcon={<ArrowForwardIcon />}
                sx={{
                  backgroundColor: '#2271b1',
                  color: '#ffffff',
                  fontWeight: '600',
                  padding: '14px 32px',
                  fontSize: '15px',
                  textTransform: 'none',
                  borderRadius: '3px',
                  boxShadow: '0 1px 0 #135e96',
                  transition: 'all 0.2s',
                  '&:hover': {
                    backgroundColor: '#135e96',
                    transform: 'translateY(-1px)',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                  }
                }}
              >
                Contact Us
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default WebDevelopment;
